<div class="main-container">
  @if (fg) {
    <form [formGroup]="fg" (submit)="update()">
      <mat-checkbox formControlName="promotionExclude" class="form-item"> </mat-checkbox>
      <div class="action-container">
        @if (promoExcludeEditMode) {
          @if (updatingInProgress) {
            <mat-spinner class="content-inline" [diameter]="20"></mat-spinner>
          }
          @if (!success && !updatingInProgress) {
            <button mat-stroked-button color="primary" type="submit">Save</button>
          }
          @if (!success && !updatingInProgress) {
            <button mat-icon-button color="accent" type="submit" (click)="toggleEditMode()" matTooltip="Cancel">
              <mat-icon>cancel</mat-icon>
            </button>
          }
        }
        @if (!editMode && !promoExcludeEditMode) {
          @if (!success) {
            <button mat-icon-button color="primary" type="submit" (click)="toggleEditMode()">
              <mat-icon>edit</mat-icon>
            </button>
          }
          @if (success) {
            <strong class="green">Changes saved</strong>
          }
        }
      </div>
    </form>
  }
</div>
